import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ListarEmpreendimentosController } from "../../../Controllers/Geral/Produtos/ProdutosControllers";
import {
    faDownload,
    faFileUpload,
    faTimes,
} from "@fortawesome/free-solid-svg-icons";
import { ChangeEvent, useRef, useState } from "react";
import { OverlayTrigger, Tab, Tabs, Tooltip } from "react-bootstrap";
import "./styles.css";
import UnForm from "../../../Components/Form";
import useAsyncCallback from "../../../hooks/useAsyncCallback";
import {
    CriarAgendamentoDeAtendimentoEmMassaController,
    ExportarExcelAgendamentosVistoriaController,
} from "../../../Controllers/VistoriaEntregaChaves/CompromissoDisponivel/CompromissoDisponivelController";
import saveAs from "file-saver";
import Select from "react-select";
import useAsyncEffect from "../../../hooks/useAsyncEffect";

export default function DisponibilidadeVistoriaEmMassa() {
    const [selectedEmpreendimento, setSelectedEmpreendimento] = useState<{
        label: string;
        value: number;
    }>();

    const selectInputRef = useRef<any>();

    const { value: lstEmpreendimentos } = useAsyncEffect(
        () =>
            ListarEmpreendimentosController().then((res) => {
                return res?.map((e) => ({
                    label: e.DS_EMPREENDIMENTO,
                    value: e.ID_EMPREENDIMENTO,
                }));
            }),
        []
    );

    const customStyles = {
        control: (base: any) => ({
            ...base,
            boxShadow: "none",
            border: "1px solid #e4e6ef",
            transition:
                "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
        }),
    };

    const [file, setFile] = useState<File>();
    const fileInputRef = useRef<HTMLInputElement>(null);

    const handleFileUpload = (e: ChangeEvent<HTMLInputElement>) => {
        if (e.target.files) {
            const uploadedFile = e.target.files[0];
            setFile(uploadedFile);
        }
    };

    const handleFileRemove = () => {
        setFile(undefined);
        if (fileInputRef.current) {
            fileInputRef.current.value = "";
        }
    };

    const {
        execute: ExportarExcelAgendamentosVistoria,
        loading: ExportarExcelAgendamentosVistoriaLoading,
    } = useAsyncCallback(ExportarExcelAgendamentosVistoriaController);

    function handleExportarExcelAgendamentosVistoria(formData: {
        data: string;
        idEmpreendimento: number;
        idUnidade: number;
    }) {
        if (selectedEmpreendimento && selectedEmpreendimento.value > 0)
            ExportarExcelAgendamentosVistoria(
                selectedEmpreendimento.value
            ).then((res) => {
                if (res) {
                    const blob = new Blob([res], {
                        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                    });
                    saveAs(blob, `Planilha-Template.xlsx`);
                }
            });
    }

    const {
        execute: CriarAgendamentoDeAtendimentoEmMassa,
        loading: CriarAgendamentoDeAtendimentoEmMassaLoading,
    } = useAsyncCallback(CriarAgendamentoDeAtendimentoEmMassaController);

    function handleCriarAgendamentoDeAtendimentoEmMassa() {
        const formData = new FormData();
        formData.append("file", file as File);
        CriarAgendamentoDeAtendimentoEmMassa(formData);
    }

    return (
        <Tabs defaultActiveKey="download">
            <Tab title="Baixar planilha" eventKey="download">
                <UnForm
                    handleSubmit={handleExportarExcelAgendamentosVistoria}
                    className="d-flex align-items-center my-4"
                >
                    <div className="col-4">
                        <label>Empreendimento</label>{" "}
                        <Select
                            name="ID_PRODUTO"
                            ref={selectInputRef}
                            options={lstEmpreendimentos}
                            value={selectedEmpreendimento}
                            isClearable
                            onChange={(e) => {
                                setSelectedEmpreendimento({
                                    label: e?.label ?? "",
                                    value: e?.value ?? 0,
                                });
                            }}
                            components={{
                                DropdownIndicator: () => null,
                                IndicatorSeparator: () => null,
                            }}
                            styles={customStyles}
                            placeholder={""}
                            noOptionsMessage={() => "Sem opções"}
                        />
                        {/* <UnForm.LazySelect
                            label="Empreendimento"
                            controller={ListarEmpreendimentosController}
                            getDS={(e) => e.DS_EMPREENDIMENTO}
                            getKeyValue={(e) => e.ID_EMPREENDIMENTO}
                            name="idEmpreendimento"
                            className="form-control"
                            onChange={handleEmpreendimentoChange}
                            placeholder="Selecione o Empreendimento"
                        >
                            <option></option>
                        </UnForm.LazySelect> */}
                    </div>

                    <div className="col-4 mt-auto">
                        <UnForm.SubmitButton
                            color="success"
                            icon={faDownload}
                            iconSize="sm"
                            loadingSize="sm"
                            disabled={
                                !selectedEmpreendimento?.value ||
                                selectedEmpreendimento?.value === 0 ||
                                ExportarExcelAgendamentosVistoriaLoading
                            }
                            loading={ExportarExcelAgendamentosVistoriaLoading}
                        >
                            Baixar Planilha
                        </UnForm.SubmitButton>
                    </div>
                </UnForm>
            </Tab>
            <Tab title="Importar planilha" eventKey="upload">
                <UnForm
                    handleSubmit={handleCriarAgendamentoDeAtendimentoEmMassa}
                    className="d-flex align-items-center my-4"
                >
                    <div className="w-50 mx-5">
                        <div>
                            <label htmlFor="formFile" className="mb-0 w-75">
                                Importar Planilha
                            </label>
                            <div className="custom-file mr-2 mt-1 position-relative file-input-container">
                                <input
                                    type="file"
                                    className="custom-file-input"
                                    accept=".xlsx, .xls"
                                    id="formFile"
                                    onChange={handleFileUpload}
                                    ref={fileInputRef}
                                />
                                <label
                                    className="custom-file-label"
                                    htmlFor="formFile"
                                >
                                    {file?.name || "Escolher arquivo..."}
                                </label>
                                {file && (
                                    <OverlayTrigger
                                        overlay={
                                            <Tooltip id="ver-info-tooltip">
                                                Remover arquivo
                                            </Tooltip>
                                        }
                                    >
                                        <button
                                            onClick={handleFileRemove}
                                            className="btn remove-file-btn"
                                        >
                                            <FontAwesomeIcon
                                                icon={faTimes}
                                                color="red"
                                            />
                                        </button>
                                    </OverlayTrigger>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="w-25 mt-auto">
                        <UnForm.SubmitButton
                            className="btn btn-success w-100"
                            disabled={
                                !file ||
                                CriarAgendamentoDeAtendimentoEmMassaLoading
                            }
                            iconSize="sm"
                            loadingSize="sm"
                            color="success"
                            icon={faFileUpload}
                            loading={
                                CriarAgendamentoDeAtendimentoEmMassaLoading
                            }
                        >
                            Importar Planilha
                        </UnForm.SubmitButton>
                    </div>
                </UnForm>
            </Tab>
        </Tabs>
    );
}
